import { Upload } from 'lucide-react';

import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';
import { Select } from '@/components/ui/Select';

export function ImportPanel({
  fileName,
  sheetNames,
  activeSheet,
  mode,
  onUpload,
  onSheetChange,
  onModeChange,
}: {
  fileName: string;
  sheetNames: string[];
  activeSheet: string;
  mode: string;
  onUpload: (file: File | null) => void;
  onSheetChange: (value: string) => void;
  onModeChange: (value: string) => void;
}) {
  return (
    <Card className="p-6">
      <div className="flex items-center gap-2 text-xl font-semibold">
        <Upload className="h-5 w-5" />
        Загрузка данных
      </div>
      <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
        Поддерживается XLSX/XLS/CSV. Каждая строка становится ребром между Location A и Location Z, а mapping можно вручную поправить ниже.
      </p>

      <div className="mt-5 rounded-3xl border border-dashed border-slate-300 bg-slate-50/80 p-5 dark:border-slate-800 dark:bg-slate-900/50">
        <label className="mb-3 block text-sm font-medium">Файл</label>
        <input
          type="file"
          accept=".xlsx,.xls,.csv"
          onChange={(event) => onUpload(event.target.files?.[0] ?? null)}
          className="block w-full text-sm"
        />
        <div className="mt-3 text-sm text-slate-500 dark:text-slate-400">
          {fileName ? `Загружен: ${fileName}` : 'Файл ещё не выбран'}
        </div>
      </div>

      <div className="mt-5 grid gap-4 md:grid-cols-2">
        <div>
          <label className="mb-2 block text-sm font-medium">Лист</label>
          <Select value={activeSheet} onChange={(event) => onSheetChange(event.target.value)} disabled={sheetNames.length === 0}>
            <option value="">Выбери лист</option>
            {sheetNames.map((name) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
          </Select>
        </div>
        <div>
          <label className="mb-2 block text-sm font-medium">Режим</label>
          <Select value={mode} onChange={(event) => onModeChange(event.target.value)}>
            <option value="latency">Минимальная задержка</option>
            <option value="cost">Минимальная стоимость</option>
            <option value="hops">Минимум хопов</option>
            <option value="balanced">Сбалансированный</option>
            <option value="pareto">Pareto frontier</option>
          </Select>
        </div>
      </div>

      <div className="mt-5 flex flex-wrap gap-2">
        <Button type="button" variant="secondary" onClick={() => onUpload(null)}>
          Очистить импорт
        </Button>
      </div>
    </Card>
  );
}
